import { takeLatest, call, put } from "redux-saga/effects";
import { request, showNotification } from "@thewebops/admin-panel";
import actions from "./actions";

function* exportHabit(action) {
  const { item } = action.payload;
  const { success, failure } = actions.exportHabit;
  try {
    yield call(request, {
      url: `admin/export_documents`,
      method: "post",
      authenticated: true,
      data: {
        exportable_id: item.id,
        exportable_type: 'Habit',
      }
    });
    showNotification('Exercise', "success");
    yield put(success(item));
  } catch (error) {
    yield put(failure());
  }
}


function* watchEntityexportHabit() {
  const { request } = actions.exportHabit;
  yield takeLatest(request, exportHabit);
}


export default [watchEntityexportHabit];
